export * from './widget';
export { name, version } from '../package.json';
